The postal code of the position location.

For example, "3000" for Melbourne CBD or "2000" for Sydney CBD.
